import { useEffect, useState } from "react";
import styles from "../PersonalInfoForm/styles.module.css";
import FormField from "../../FormField";
import { FormattedMessage, useIntl } from "react-intl";
import useCountryLanguages from "../../../hooks/useCountryLanguages";
import propTypes from "prop-types";
const CocoLanguageForm = ({
  formData,
  handleChange,
  handleOpenSample,
  versionInfo,
  setFormData,
}) => {
  const intl = useIntl();
  const [languages, setLanguages] = useState([]);
  const { getCountryLanguages } = useCountryLanguages();
  useEffect(() => {
    getCountryLanguages(formData?.controller_code, formData?.customer_scope)
      .then((response) => {
        setLanguages(response);
        if (response?.length > 0) {
          const validLanguages = response?.map((lang) => lang?.value);
          if (!validLanguages?.includes(formData?.language)) {
            setFormData((prev) => ({ ...prev, language: validLanguages[0] }));
          }
        } else setFormData((prev) => ({ ...prev, language: "" }));
      })
      .catch((error) => {
        console.error("Error fetching country languages:", error);
        setFormData((prev) => ({ ...prev, language: "" }));
      });
  }, []);

  return (
    <div className={styles["personal-info-container"]}>
      <div className={styles["language-conatiner"]}>
        <FormField
          formType="coco"
          value={formData.language}
          name="language"
          type="select"
          id="language"
          label={intl.formatMessage({
            id: "coco.rc.language-label",
            defaultMessage: "Please select the legal text Language",
          })}
          handleChange={handleChange}
          options={languages}
          selectStyle={{ height: 40 }}
          rules={{
            required: true,
            hasSubmitted: formData?.hasSubmitted || false,
            message: versionInfo?.requiredValidationError,
          }}
        />
        {(versionInfo?.requiredFormPreview == "1" ||
          versionInfo?.requiredFormPreview == "") && (
          <button className={styles["btn-preview"]} onClick={handleOpenSample}>
            <FormattedMessage
              id="coco.rc.form-preview"
              defaultMessage="HCP Content Form Preview"
            />
          </button>
        )}
      </div>
    </div>
  );
};
export default CocoLanguageForm;

CocoLanguageForm.propTypes = {
  formData: propTypes.object.isRequired,
  handleChange: propTypes.func.isRequired,
  handleOpenSample: propTypes.func.isRequired,
  versionInfo: propTypes.object.isRequired,
  setFormData: propTypes.func.isRequired,
};
